import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS } from 'common/constants';
import { RootState } from 'store';
import { RECONCILED, SETTLED } from './constants';
import { formattedDate } from './helpers';
import {
  ReconciliationState,
  ReconciliationReportDataType,
  PaymentStatusUpdateDataType
} from './types';

const initialState: ReconciliationState = {
  selectedReconcileRecords: [],
  retryRecords: []
};

export const reconciliationSlice = createSlice({
  name: REDUX_SLICE_KEYS.reconciliationReport,
  initialState,
  reducers: {
    setSelectedReconcileRecords: (
      state,
      action: PayloadAction<ReconciliationReportDataType[]>
    ): void => {
      state.selectedReconcileRecords = action.payload;
    },
    clearSelectedReconcileRecords: (state): void => {
      state.selectedReconcileRecords = initialState.selectedReconcileRecords;
    },
    setRetryRecords: (
      state,
      action: PayloadAction<PaymentStatusUpdateDataType>
    ): void => {
      state.retryRecords = action.payload;
    }
  }
});

export const {
  setSelectedReconcileRecords,
  clearSelectedReconcileRecords,
  setRetryRecords
} = reconciliationSlice.actions;

export const getInitialState = (state: RootState): ReconciliationState =>
  state.reconciliation;

export const getSelectedReconcileRecords = createSelector(
  getInitialState,
  ({ selectedReconcileRecords }) => selectedReconcileRecords
);
export const getReconcileRecordsPayload = createSelector(
  getSelectedReconcileRecords,
  selectedReconcileRecords =>
    selectedReconcileRecords.map(data => {
      const {
        payableId,
        vendorId,
        settledAmount,
        settledDate,
        transactionDate,
        transactionNumber,
        status
      } = data;

      return {
        payableId,
        vendorNo: vendorId,
        settledAmount,
        settledDate: formattedDate(settledDate),
        transactionDate: formattedDate(transactionDate),
        transactionNumber,
        changeStatusTo: status === RECONCILED ? SETTLED : RECONCILED
      };
    })
);

export const getRetryRecords = createSelector(
  getInitialState,
  ({ retryRecords }) => retryRecords
);

export default reconciliationSlice.reducer;
